import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AppProviders } from './app/providers/app-providers'
import { router } from './app/router'
import { initSentry } from './shared/observability/sentry'
import {
  clearChunkLoadRecoveryFlag,
  registerChunkLoadRecovery,
} from './shared/lib/chunk-load-recovery'
import { consumeDeskSessionHandoff } from './shared/lib/desk-portal-redirect'
import './styles/globals.css'

// Adopt a cross-desk login handoff before any session query reads localStorage.
consumeDeskSessionHandoff()

registerChunkLoadRecovery()
initSentry()
clearChunkLoadRecoveryFlag()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
